module.exports = __webpack_public_path__ + "media/assets/images/title_window_daily_report-a0ee99059c3d2251000ed7aabdcdf8bc.png";